import { FaInbox } from 'react-icons/fa';

const BLOCK = 'LStudio__app_kit';

/*
    🔥 COMPONENTES DE ESTADO

    Los tres momentos en los que una vista NO tiene datos que mostrar:
    está cargando, no hay nada, o algo falló. Casi siempre se resuelven
    a mano en cada pantalla y quedan distintos entre sí.
*/

/*
    🔥 SKELETON

    ⚠️ Por qué no un spinner: el esqueleto muestra la FORMA de lo que
       viene, así el salto al cargar es menor y la espera se siente
       más corta. Un spinner no dice nada sobre el contenido.
*/
export const Skeleton = ({
    variant = 'text',              // text | title | box | circle | avatar
    width, height, count = 1, className = '',
}) => (
    <>
        {
            Array.from({ length: count }, (_, i) => (
                <span key={i} className={`${BLOCK}__skeleton ${className}`}
                    data-variant={variant}
                    style={{ width, height }} aria-hidden="true" />
            ))
        }
    </>
);

/* 🔥 Esqueleto de una fila de tabla */
export const SkeletonRow = ({ columns = 4 }) => (
    <div className={`${BLOCK}__skeleton_row`}>
        {Array.from({ length: columns }, (_, i) => <Skeleton key={i} variant="text" />)}
    </div>
);

/*
    🔥 ESTADO VACÍO

    ⚠️ Un vacío SIEMPRE debería ofrecer una salida. "No hay resultados"
       a secas deja al usuario sin saber qué hacer; con una acción,
       la pantalla vacía se vuelve el primer paso.
*/
export const EmptyState = ({
    icon = <FaInbox />,
    title = 'No hay nada por acá',
    description,
    action = null,
    size = 'md',                   // sm | md | lg
}) => (
    <div className={`${BLOCK}__empty`} data-size={size}>

        <span className={`${BLOCK}__empty_icon`} aria-hidden="true">{icon}</span>

        <p className={`${BLOCK}__empty_title`}>{title}</p>

        {description && <p className={`${BLOCK}__empty_text`}>{description}</p>}

        {action && <div className={`${BLOCK}__empty_action`}>{action}</div>}

    </div>
);

/*
    🔥 SPINNER
*/
export const Spinner = ({ size = 20, label = 'Cargando…', isInline = false }) => (
    <span className={`${BLOCK}__spinner_wrap`} data-inline={isInline} role="status" aria-live="polite">
        <span className={`${BLOCK}__spinner`} style={{ width: size, height: size }} aria-hidden="true" />
        {!isInline && <span className={`${BLOCK}__spinner_label`}>{label}</span>}
    </span>
);

/*
    🔥 BARRA DE PROGRESO

    Con value = null queda indeterminada: se usa cuando no sabés cuánto
    falta, y es más honesto que inventar un porcentaje.
*/
export const Progress = ({
    value = null, max = 100, label, tone = 'accent',   // accent | ok | warn | danger
    showValue = true, size = 'md',                     // sm | md | lg
}) => {

    const IS_INDETERMINATE = value === null || value === undefined;

    const PERCENT = IS_INDETERMINATE ? 0 : Math.min(100, Math.max(0, (value * 100) / max));

    return (
        <div className={`${BLOCK}__progress`} data-tone={tone} data-size={size}>

            {
                (label || showValue) && (
                    <div className={`${BLOCK}__progress_head`}>
                        {label && <span>{label}</span>}
                        {showValue && !IS_INDETERMINATE && <span>{Math.round(PERCENT)}%</span>}
                    </div>
                )
            }

            <div className={`${BLOCK}__progress_track`}
                role="progressbar"
                aria-valuenow={IS_INDETERMINATE ? undefined : value}
                aria-valuemin={0} aria-valuemax={max} >
                <span className={`${BLOCK}__progress_fill`}
                    data-indeterminate={IS_INDETERMINATE}
                    style={IS_INDETERMINATE ? undefined : { width: `${PERCENT}%` }} />
            </div>

        </div>
    );
};
